import { ApplicationRef, enableProdMode } from '@angular/core';
import { bootstrapApplication, enableDebugTools } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import { appConfig } from '@app/app.config';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).then((module) => {
  if (!environment.production) {
    enableDebugTools(module.injector.get(ApplicationRef).components[0]);
  }
});
